import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../project/project.service';
import { SigninService } from '../auth/signin/signin.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-department-limit',
  templateUrl: './department-limit.component.html',
  styleUrls: ['./department-limit.component.scss']
})
export class DepartmentLimitComponent implements OnInit {
  selectedDepartment: string = '';
  fullDataList = [
    { department: 'Education Department', name: 'Project A',amount:'₹50,00,000', received: '₹50,00,000', spent: '₹30,00,000', available: '₹20,00,000', excess:'₹0'},
    { department: 'Education Department', name: 'Project B',amount:'₹50,00,000', received: '₹60,00,000', spent: '₹40,00,000', available: '₹20,00,000', excess:'₹0'},
    { department: 'Health Department', name: 'Project C',amount:'₹50,00,000', received: '₹40,00,000', spent: '₹60,00,000', available: '₹0', excess:'₹-20,00,000'},
    { department: 'Health Department', name: 'Project D',amount:'₹90,00,000', received: '₹80,00,000', spent: '₹10,00,000', available: '₹70,00,000', excess:'₹0'},
  ];

  tempFiltered: any[] = [];
  filteredList: any[] = [];
  totalAvailableAmount: number = 0;
  AgencyLists: any;
  agency:any;
  districtId: any;


  ngOnInit(): void {
     this.projectService.getAgency().subscribe((res: any) => {
      this.AgencyLists = res.body.data;
    });
  }

  constructor(
      private projectService: ProjectService,
      private loginService:SigninService
    ) {
     this.getUserrole();
    }

    getUserrole() {
    this.loginService.getuserDto().subscribe(
      (res) => {
        if (res.body.levelMasterId.levelType.id === 2) {
          this.districtId = res.body.levelMasterId.id;
        } else {
          this.districtId = null;
        }
      },
      (onError) => { }
    )
  }

  

  agencyChange () {
    console.log('agency',this.agency)
     this.projectService.asAmountWise(this.agency.id,this.districtId).subscribe((res: any) => {
     this.filteredList = _.uniqBy(res.body, 'PROJECT_ID');
     this.calculateTotal();
     
    });
  }

  paginate(event: any) {
    const start = event.first;
    const end = start + event.rows;
    this.filteredList = this.tempFiltered.slice(start, end);
  }

calculateTotal() {
  const totalFunds = this.filteredList.reduce((acc, item) => {
      return acc +item.TOTAL_FUNDS_RECEIVED;
  }, 0);
   const totalSpentAmount = this.filteredList.reduce((acc, item) => {
      return acc + item.EXPENDITURE;
  }, 0);
  console.log('totalFunds',totalFunds);
   console.log('totalSpentAmount',totalSpentAmount);
  this.totalAvailableAmount = totalFunds - totalSpentAmount;
 
}



  convertRupeeToNumber(value: string): number {
    return Number(value.replace(/₹|,/g, '').replace(/-/g, '')) * (value.includes('-') ? -1 : 1);
  }
}
